import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useDetailsModalControls = () => {
    const modalControls = useBrowserModalControls<{ id: string; modalTitle?: string }>('details-modal');

    return {
        isDetailsModalOpen: modalControls.isModalOpen,
        openDetailsModal: modalControls.openModal,
        closeDetailsModal: modalControls.closeModal,
        ...modalControls.modalData,
    };
};
